module.exports = __webpack_public_path__ + "img/file.efd78b15.png";